import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  input,
  model,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-choice',
  templateUrl: './choice.component.html',
  styleUrls: ['./choice.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class ChoiceComponent implements OnInit {
  readonly paymentOption = input<any>();
  readonly value = input<string>();
  readonly disabled = model(false);
  readonly selected = model(false);

  @Output() selectedChanged = new EventEmitter<any>();

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.cdr.detectChanges();
  }

  selectPaymentOption(): void {
    const next = !this.selected();
    // Update the local selected state immediately so the highlight reflects the
    // click on the first attempt, regardless of the parent's (OnPush) change
    // detection timing. The parent re-syncs this via the [selected] binding, so
    // it will be corrected if the parent rejects the selection (e.g. modal cancel).
    this.selected.set(next);
    this.selectedChanged.emit(next);
  }
}
